import { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError, formatEuro } from "@/lib/api";
import { RouteBlock, RideMeta } from "@/components/fleet/RideCard";
import { EscrowSeal } from "@/components/fleet/EscrowSeal";
import { t } from "@/lib/i18n";

const Row = ({ label, value, accent, testid }) => (
  <div className="flex items-center justify-between gap-3 py-2 border-b border-[#27272A] last:border-b-0">
    <span className="text-sm text-[#94A3B8]">{label}</span>
    <span data-testid={testid} className={`ff-display text-xl font-extrabold ${accent || "text-white"}`}>{value}</span>
  </div>
);

export const BookDialog = ({ booking, onClose, onBooked }) => {
  const [loading, setLoading] = useState(false);
  const ride = booking?.ride;

  const confirm = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/rides/${ride.id}/checkout`, { pin: booking.pin, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(apiError(err, t("Prenotazione non riuscita")));
      if (err?.response?.status === 409) {
        onBooked();
        onClose();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!ride} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="book-dialog" className="ff-glass-panel sm:max-w-md max-h-[92vh] overflow-y-auto rounded-2xl p-5 sm:p-7">
        <DialogHeader className="text-left">
          <DialogTitle className="ff-display text-2xl font-extrabold">{t("Conferma e blocca")}</DialogTitle>
          <DialogDescription className="text-[#94A3B8] text-sm">{t("Controlla i dettagli e blocca la corsa.")}</DialogDescription>
        </DialogHeader>
        {ride && (
          <div className="flex flex-col gap-4">
            <RouteBlock ride={ride} />
            <RideMeta ride={ride} />
            <div className="rounded-xl border border-[#27272A] bg-black px-4 py-1">
              <Row label={t("Tariffa totale")} value={formatEuro(ride.fare)} testid="book-total" />
              <Row label={t("Al collega cedente a corsa completata (90%)")} value={formatEuro(ride.executor_share)} accent="text-[#10B981]" testid="book-executor-share" />
              <Row label={t("Quota FLEETFLOW (10%)")} value={formatEuro(ride.platform_fee)} testid="book-platform-fee" />
            </div>
            <EscrowSeal testid="book-escrow-seal" />
            <button type="button" data-testid="book-confirm-button" disabled={loading} onClick={confirm} className="ff-btn-paypal h-16 w-full text-base">
              <Lock size={18} strokeWidth={2.5} /> {loading ? t("Apertura PayPal…") : <span>{t("PAGA CON")} <b className="italic">PayPal</b> {t("E BLOCCA")}</span>}
            </button>
            <p data-testid="book-wallet-hint" className="text-center text-sm font-semibold text-white -mt-1">{t("Conto PayPal o carta di credito/debito • fondi custoditi in Escrow FLEETFLOW")}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
